import * as firebase from "firebase";
import setLocalUser from "./setLocalUser";

export default async ({ prompt } = { prompt: false }) => {
    return new Promise(async (resolve, reject) => {
        try {
            let user;
            if (prompt) {
                const result = await firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider());
                user = result.user;
            } else {
                user = await getCurrentUser(firebase.auth());
            }
            const token = await (user as any).getIdToken();
            setLocalUser({ userId: user.uid, userToken: token });
            resolve({
                id: user.uid,
                photoURL: user.photoURL,
                token,
                username: user.displayName || user.email
            });
        } catch (error) {
            console.log(error);
        }
    });
}

const getCurrentUser = async (auth) => {
    return new Promise((resolve, reject) => {
        auth.onAuthStateChanged(user => {
            if (user) {
                resolve(user);
            }
        });
    });
}


// WEBPACK FOOTER //
// ./src/user/signInUser.ts